// extracted by mini-css-extract-plugin
export default {"formElementsContainer":"IssueFormElements-module__formElementsContainer--tMcTq","markdownElementWrapper":"IssueFormElements-module__markdownElementWrapper--fBypI"};